class KpiNamesModel {
  constructor({
    kpiNameId = null,
    kpiName = "",
    companyId = null,
    perspectiveId = null,
    kpiFormula = "",
    description = "",
    theme = "",
    accountability = "",
    units = "",
    generatedFrom = "",
    source = "",
  }) {
    this.kpiNameId = kpiNameId;
    this.kpiName = kpiName;
    this.companyId = companyId;
    this.perspectiveId = perspectiveId;
    this.kpiFormula = kpiFormula;
    this.description = description;
    this.theme = theme;
    this.accountability = accountability;
    this.units = units;
    this.generatedFrom = generatedFrom;
    this.source = source;
  }

  // Example method to format the date
  getFormattedCreatedAt() {
    return this.createdAt.toISOString(); // Convert to ISO format (YYYY-MM-DDTHH:mm:ss.sssZ)
  }
}

export default KpiNamesModel;
